/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-right': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M307.298 974.784l6.186-5.302 461.017-400.628c15.613-13.55 25.334-33.877 25.334-56.56 0-22.682-10.016-43.008-25.334-56.559L314.368 55.402l-7.659-6.775c-7.364-5.008-16.202-7.954-25.628-7.954-25.629 0-46.544 21.799-46.544 48.9v844.854c0 27.101 20.915 48.9 46.544 48.9 9.72 0 18.853-3.24 26.217-8.543z"/>'
  }
})
